import { render, staticRenderFns } from "./Comp47t2.vue?vue&type=template&id=4db466c2&scoped=true&"
import script from "./Comp47t2.vue?vue&type=script&lang=js&"
export * from "./Comp47t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp47t2.vue?vue&type=style&index=0&id=4db466c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db466c2",
  null
  
)

export default component.exports